export const PROFILE_ACTIONS = {
    TRUST_USER: 'trust_user',
    PROMOTE: 'promote',
    REJECT_AVATAR: 'reject_avatar',
    REJECT_NAME: 'reject_name',
};

export const LIST_TYPES = {
    QUEUE: 'queue',
    SEARCH: 'search',
};

export const LIST_ACTIONS = {
    RENAME: 'rename',
    EDIT: 'edit',
    DELETE: 'delete',
    UPDATE_SLA: 'update_sla',
    UPDATE_NOTES: 'update_notes',
    EXPORT_SEARCH: 'export_search',
};

export const TAG_SOURCES = {
    AUTO_MOD: 'auto_mod',
    MODERATOR: 'moderator',
    COMMUNITY: 'community',
};

export const TAG_STATUSES = {
    PROPOSED: 'proposed',
    REJECTED: 'rejected',
    CONFIRMED: 'confirmed',
};

export const ICON_STATUSES = {
    NONE: 'none',
    SUCCESS: 'success',
    ERROR: 'error',
};

export const PROCESSING_STATUSES = {
    VISIBLE: 'visible',
    DISABLED: 'disabled',
    AWAITING_MODERATION: 'awaiting_moderation',
    SPAM: 'spam',
    DELETED: 'deleted',
};

export const COMMUNITY_PROPOSED = 'community_proposed';
export const KEEPCON_PROPOSED = 'keepcon_proposed';
